import authRules from '../authRules';

const resourceInfo = (user) => {
  const { resourceInfo } = user.securityLevels;
  if (resourceInfo >= authRules.resourceInfo.resourceInfo) {
    return true;
  } else {
    return false;
  }
}

export default resourceInfo;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/resourceInfo.js